import { render, staticRenderFns } from "./approvalHeader.vue?vue&type=template&id=5a84806e&scoped=true&"
import script from "./approvalHeader.vue?vue&type=script&lang=js&"
export * from "./approvalHeader.vue?vue&type=script&lang=js&"
import style0 from "./approvalHeader.vue?vue&type=style&index=0&id=5a84806e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84806e",
  null
  
)

export default component.exports